export default __webpack_public_path__ + "static/media/wallet-feat.936d7961.svg";